import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getClassPlanGrid = async (classId, idTurmaDisc, month) => {
  const res = await api.get(`ClassDiaryV1/class/${classId}/class-plan/grid`, {
    params: { idTurmaDisc, month }
  });
  return res.data;
};

const saveClassPlanJob = async data => {
  const res = await api.post("ClassDiaryV1/class-plan/job", {
    ...data,
    externalData: UserStore.getUserExternalInfo()
  });
  return res.data;
};

export default {
  getClassPlanGrid,
  saveClassPlanJob
};
